module.exports = __webpack_public_path__ + "static/media/Dos@2x.61d3dec8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dos@2x.png
// module id = 175
// module chunks = 0